export default "__VITE_ASSET__f5f01952__"